import {addClass, findID, getDataAttributes, mergeDeepObject, VGLog} from "./util";
import Toast from "../../boot/js/toast";

const VGToastSetting = {
	on: function (arg) {
		let params = mergeDeepObject({
			position: 'bottom end',
			class: ''
		}, arg);

		const $container = document.createElement("div");
		$container.id = 'toast-container';
		addClass($container, params.position + params.class);

		document.body.append($container);
	}
}

const VGToast = {
	init: function (arg = {}) {
		let params = {
			autohide: false,
			delay: 5000,
			animation: true,
			theme: 'default',
			text: {
				header: '',
				body: ''
			}
		};

		const $container = findID('toast-container');

		if ($container) {
			const d= new Date();
			let toast = document.createElement('div');
			toast.classList.add('toast');
			toast.id = 'toast-' + d.getTime() + Math.floor(Math.random() * 10);

			$container.append(toast);

			params.toast = toast;
			params = this.setParams(params, arg);
			params = this.build(params);

			this.show(params);
		} else {
			VGLog("error", ["Мон Синьор! Тоастов сегодня не будет"]);
			return false;
		}
	},

	show: function (params) {
		let option = ['autohide', 'delay', 'animation'],
			element = params.toast;

		for (const param in params) {
			if (!option.includes(param)) {
				delete params[param];
			}
		}

		const toast = new Toast(element, params);
		toast.show();
	},

	build: function (params) {
		let $toast = params.toast;

		if (params.theme !== 'default') {
			addClass($toast, 'toast-' + params.theme);
		}

		let btnClose = document.createElement('button');
		btnClose.setAttribute('type', 'button');
		btnClose.setAttribute('data-bs-dismiss', 'toast');
		btnClose.setAttribute('aria-label', 'Close');
		btnClose.classList.add('btn-close');

		let bodyToast = document.createElement('div');
		bodyToast.classList.add('toast-body');
		bodyToast.innerHTML = params.text.body;

		$toast.append(bodyToast);

		if (params.text.header) {
			let headerToast = document.createElement('div');
			headerToast.classList.add('toast-header');
			headerToast.innerHTML = '<strong class="me-auto">' + params.text.header +'</strong>';
			headerToast.append(btnClose);

			$toast.prepend(headerToast);
		} else {
			let dFlex= document.createElement('div');
			dFlex.classList.add('d-flex');
			dFlex.prepend(bodyToast);

			addClass(btnClose, 'me-2 m-auto');
			dFlex.append(btnClose);

			$toast.append(dFlex);
		}

		return params;
	},

	setParams: function (params, arg) {
		let dataParams = getDataAttributes(params.toast);

		if ('data-autohide' in dataParams) {
			params.autohide = dataParams['data-autohide'] !== 'false';
			delete dataParams['data-autohide'];
		}

		if ('data-animation' in dataParams) {
			params.animation = dataParams['data-animation'] !== 'false';
			delete dataParams['data-animation'];
		}

		if ('data-delay' in dataParams) {
			params.delay = Number(dataParams['data-delay']);
			delete dataParams['data-delay'];
		}

		return mergeDeepObject(dataParams, params, arg);
	},
}

function onReady() {
	VGToastSetting.on({
		position: 'bottom start',
	});
}

document.addEventListener('DOMContentLoaded', onReady);
if (window.Turbo !== 'undefined' && typeof onTurboRender === 'function') {
	onTurboRender(onReady);
}

export default VGToast;
